<template>
  <div>
    <!-- 列表模式 -->
    <template v-if="!printMode">
    <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <store-tenant-select domain="stock" @change="handleStoreTenantChange"></store-tenant-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="请选择仓库"
                    allow-clear
                    style="width: 100%"
                    v-model="queryParam.depotId">
                    <a-select-option v-for="(item, index) in depotList" :key="index" :value="item.id">
                      {{ item.depotName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="条码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入条码" v-model="queryParam.barCode"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入名称、助记码" v-model="queryParam.name"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a-button style="margin-left: 8px" icon="printer" v-if="btnEnableList.indexOf('5')>-1"
                    @click="handlePrint">打印</a-button>
                  <a-button style="margin-left: 8px" @click="exportExcel" icon="download" v-if="btnEnableList.indexOf('3')>-1">导出</a-button>
                  <a @click="toggleSearchStatus = !toggleSearchStatus" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
            <template v-if="toggleSearchStatus">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="规格" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入规格" v-model="queryParam.standard"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="型号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入型号" v-model="queryParam.model"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="颜色" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入颜色" v-model="queryParam.color"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="品牌" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入品牌" v-model="queryParam.brand"></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-tree-select
                      style="width: 100%"
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      allow-clear
                      :treeData="categoryTree"
                      v-model="queryParam.categoryId"
                      placeholder="请选择类别">
                    </a-tree-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </a-form>
        </div>
        <section ref="print" id="reportPrint">
          <a-table
            bordered
            ref="table"
            size="middle"
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
          </a-table>
          <a-row :gutter="24" style="margin-top: 8px; textAlign: right">
            <a-col :md="24" :sm="24">
              <a-pagination
                @change="paginationChange"
                @showSizeChange="paginationShowSizeChange"
                size="small"
                show-size-changer
                show-quick-jumper
                :current="ipagination.current"
                :page-size="ipagination.pageSize"
                :page-size-options="ipagination.pageSizeOptions"
                :total="ipagination.total"
              />
            </a-col>
          </a-row>
        </section>
      </a-card>
    </a-col>
    </a-row>
    </template>

    <!-- 打印模式 -->
    <template v-if="printMode">
      <div class="print-header" style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
        <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint
        :visible="true"
        :tableData="printDataSource"
        :queryParam="queryParam"
        billType="MINUS_STOCK"
        billTypeName="负库存统计"
        :buildData="buildPrintData"
        :embedded="true"
        @designer-change="onDesignerChange"
        @back="printMode = false"
      />
    </template>
  </div>
</template>
<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { queryMaterialCategoryTreeList } from '@/api/api'
  import { getAction } from '@/api/manage'
  import moment from 'moment'
  import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
  import StoreTenantSelect from '@/components/StoreTenantSelect'
  import { defColumns, buildPrintData } from './minusStockConfig'

  export default {
    name: "MinusStockStatisticsList",
    mixins: [JeecgListMixin],
    components: {
      ReportPrint,
      StoreTenantSelect
    },
    data() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
        queryParam: {
          depotId: undefined,
          barCode: '',
          name: '',
          standard: '',
          model: '',
          color: '',
          brand: '',
          categoryId: undefined
        },
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          total: 0
        },
        depotList: [],
        categoryTree: [],
        columns: [],
        defColumns: defColumns,
        url: {
          list: '/api/plugin/minus-stock-statistics/minusStockStatistics/getList'
        },
        urlPath: '/plugin/minus-stock-statistics',
        printDataSource: [],
        printMode: false,
        printTitle: '负库存统计-打印预览',
        isorter: {
          column: 'id',
          order: 'desc'
        }
      }
    },
    created() {
      this.columns = this.defColumns
      this.getDepotData()
      this.loadCategoryTreeData()
    },
    methods: {
      moment,
      buildPrintData,
      handleStoreTenantChange() {
        this.searchQuery()
      },
      loadCategoryTreeData() {
        queryMaterialCategoryTreeList({ id: '' }).then((res) => {
          if (res) {
            this.categoryTree = []
            for (let i = 0; i < res.length; i++) {
              this.categoryTree.push(res[i])
            }
          }
        }).catch((err) => {
          console.error('获取类别失败', err)
        })
      },
      getDepotData() {
        getAction('/depot/findDepotByCurrentUser').then((res) => {
          if (res && res.code === 200 && res.data) {
            this.depotList = res.data
          }
        }).catch((err) => {
          console.error('获取仓库失败', err)
        })
      },
      async fetchAllData() {
        const pageSize = 500
        let allRows = []
        let total = 0

        const baseParams = {
          depotId: this.queryParam.depotId || undefined,
          barCode: this.queryParam.barCode || undefined,
          name: this.queryParam.name || undefined,
          standard: this.queryParam.standard || undefined,
          model: this.queryParam.model || undefined,
          color: this.queryParam.color || undefined,
          brand: this.queryParam.brand || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          column: this.isorter.column || 'id',
          order: this.isorter.order || 'desc',
          pageSize: pageSize
        }

        const firstParams = { ...baseParams, currentPage: 1 }
        const firstRes = await getAction(this.url.list, firstParams)
        if (firstRes && firstRes.code === 200 && firstRes.data) {
          total = firstRes.data.total || 0
          const rows = firstRes.data.rows || []
          allRows = allRows.concat(rows)
        }

        const totalPages = Math.ceil(total / pageSize)
        for (let page = 2; page <= totalPages; page++) {
          const params = { ...baseParams, currentPage: page }
          const res = await getAction(this.url.list, params)
          if (res && res.code === 200 && res.data) {
            const rows = res.data.rows || []
            allRows = allRows.concat(rows)
          }
        }

        allRows.forEach((row, i) => {
          row.rowIndex = i + 1
        })

        this.addTotalRow(allRows)
        return allRows
      },
      addTotalRow(dataSource) {
        if (dataSource.length === 0) return
        const totalRow = { rowIndex: '合计' }

        let totalCurrentNumber = 0
        dataSource.forEach(row => {
          if (row.currentNumber) {
            totalCurrentNumber += Number.parseFloat(row.currentNumber)
          }
        })
        totalRow.currentNumber = parseFloat(totalCurrentNumber.toFixed(2))

        dataSource.push(totalRow)
      },
      async handlePrint() {
        this.loading = true
        try {
          const allRows = await this.fetchAllData()
          if (!allRows || allRows.length === 0) {
            this.$message.warning('暂无数据可打印')
            return
          }
          this.printDataSource = allRows
          this.printTitle = '负库存统计-打印预览'
          this.printMode = true
        } catch (err) {
          this.$message.error('获取打印数据失败: ' + (err.message || '未知错误'))
          console.error(err)
        } finally {
          this.loading = false
        }
      },
      onDesignerChange(visible) {
        this.printTitle = visible ? '负库存统计-报表设计' : '负库存统计-打印预览'
      },
      loadData() {
        const params = {
          depotId: this.queryParam.depotId || undefined,
          barCode: this.queryParam.barCode || undefined,
          name: this.queryParam.name || undefined,
          standard: this.queryParam.standard || undefined,
          model: this.queryParam.model || undefined,
          color: this.queryParam.color || undefined,
          brand: this.queryParam.brand || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          column: this.isorter.column || 'id',
          order: this.isorter.order || 'desc',
          currentPage: this.ipagination.current,
          pageSize: this.ipagination.pageSize
        }
        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res && res.code === 200 && res.data) {
            const rows = res.data.rows || []
            rows.forEach((row, i) => {
              row.rowIndex = (this.ipagination.current - 1) * this.ipagination.pageSize + i + 1
            })
            this.dataSource = rows
            this.ipagination.total = res.data.total || 0
            this.tableAddTotalRow(this.columns, this.dataSource)
          } else if (res && res.code === 510) {
            this.$message.warning(res.data)
          } else {
            this.dataSource = []
            this.ipagination.total = 0
          }
          this.loading = false
        }).catch((err) => {
          this.loading = false
          this.$message.error('查询失败: ' + (err.message || '未知错误'))
          console.error(err)
        })
      },
      tableAddTotalRow(columns, dataSource) {
        if (dataSource.length > 0) {
          let numKey = 'rowIndex'
          let totalRow = { [numKey]: '合计' }
          let parseCols = 'currentNumber,'
          columns.forEach(column => {
            let { key, dataIndex } = column
            if (![key, dataIndex].includes(numKey)) {
              let total = 0
              let hasSum = false
              dataSource.forEach(data => {
                if (parseCols.indexOf(dataIndex + ',') > -1) {
                  hasSum = true
                  if (data[dataIndex]) {
                    total += Number.parseFloat(data[dataIndex])
                  }
                }
              })
              if (hasSum) {
                totalRow[dataIndex] = parseFloat(total.toFixed(2))
              }
            }
          })
          dataSource.push(totalRow)
        }
      },
      handleTableChange(pagination, filters, sorter) {
        if (sorter && sorter.column) {
          this.isorter.column = sorter.field || sorter.columnKey || 'id'
          this.isorter.order = sorter.order || 'desc'
        }
        if (pagination) {
          this.ipagination.current = pagination.current
          this.ipagination.pageSize = pagination.pageSize
        }
        this.loadData()
      },
      searchReset() {
        this.queryParam = {
          depotId: undefined,
          barCode: '',
          name: '',
          standard: '',
          model: '',
          color: '',
          brand: '',
          categoryId: undefined
        }
        this.ipagination.current = 1
        this.loadData()
      },
      exportExcel() {
        const list = []
        const head = '仓库名称,条码,名称,规格,型号,颜色,单位,单价,当前库存'
        const exportData = this.dataSource.filter(item => item.rowIndex !== '合计')
        for (let i = 0; i < exportData.length; i++) {
          const ds = exportData[i]
          list.push([
            ds.depotName || '',
            ds.barCode || '',
            ds.name || '',
            ds.standard || '',
            ds.model || '',
            ds.color || '',
            ds.unit || '',
            ds.purchaseDecimal || 0,
            ds.currentNumber || 0
          ])
        }
        let tip = '查询条件'
        if (this.queryParam.depotId) {
          tip += ', 仓库ID=' + this.queryParam.depotId
        }
        if (this.queryParam.barCode) {
          tip += ', 条码=' + this.queryParam.barCode
        }
        if (this.queryParam.name) {
          tip += ', 名称=' + this.queryParam.name
        }
        let totalItem = ['-', '-', '-', '-', '-', '-', '-', '-', 0]
        for (let i = 0; i < exportData.length; i++) {
          const ds = exportData[i]
          totalItem[8] += Number.parseFloat(ds.currentNumber || 0)
        }
        totalItem[8] = totalItem[8].toFixed(2)
        list.push(totalItem)
        this.handleExportXlsPost('负库存统计', '负库存统计', head, tip, list)
      }
    }
  }
</script>
<style scoped>
</style>